"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const antiagingskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-antiagingskin` : '') + (description ? ` desc-antiagingskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-antiagingskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-antiagingskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25.23h1.9a.75.75 0 0 1 0 1.5h-1.17v4.04A6.98 6.98 0 0 1 15.14 12a6.98 6.98 0 0 1 3.84 6.23v4.04h1.16a.75.75 0 0 1 0 1.5H3.85a.75.75 0 0 1 0-1.5h1.17v-4.04A6.98 6.98 0 0 1 8.86 12a6.98 6.98 0 0 1-3.84-6.23V1.73H3.85a.75.75 0 0 1 0-1.5h14.4Zm-8.6 19.49a.75.75 0 0 1-.53.22h-2.6v2.33h10.96v-2.33h-2.6a.75.75 0 0 1-.54-.22L12 17.37l-2.35 2.35ZM12 12.75a5.48 5.48 0 0 0-5.48 5.48v.2h2.3l2.65-2.65.06-.05a.75.75 0 0 1 1 .05l2.65 2.66h2.3v-.21A5.48 5.48 0 0 0 12 12.75Zm-3-2.4c.8.54 1.75.84 2.73.9h.54a5.48 5.48 0 0 0 2.73-.9H9ZM6.52 5.78c0 1.11.34 2.18.95 3.09h9.06c.61-.9.95-1.98.95-3.09V1.73H6.52v4.04Z",
    fill: "#232323"
  }));
};
var _default = exports.default = antiagingskin;